import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';

export type CodeFieldLanguage = 'json';

export interface CodeFieldOptions {
	codeLanguage?: CodeFieldLanguage;
}

export default defineFieldTypeTemplate<CodeFieldOptions>({
	type: 'primitive',
	id: 'json',
	name: '$t:field_types.json.name',
	description: '$t:field_types.json.description',
	icon: 'lucide:braces',
	sort: 210,
	keywords: ['json', 'syntax', 'editor', 'code'],
	supportedPrimitiveTypes: ['json', 'string'],
});
